import { Injectable, inject } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private breakpointObserver = inject(BreakpointObserver);

  /** True when viewport is handset or small tablet (< 960px) */
  isSmallScreen = toSignal(
    this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small])
      .pipe(map((result) => result.matches)),
    { initialValue: false }
  );

  /** True when viewport is a phone-sized screen (< 768px) */
  isMobileScreen = toSignal(
    this.breakpointObserver
      .observe(['(max-width: 767.98px)'])
      .pipe(map((result) => result.matches)),
    { initialValue: false }
  );
}
